import { useDispatch } from 'react-redux';
import useIsAccountActivationRequired from './useIsAccountActivationRequired';
import { showModal, hideModal } from 'actions/modal';
import {
    CONFIRM_MODAL,
    ACCOUNT_BLOCKED_MODAL,
} from 'constants/shared/modalTypes';
import useTranslate from 'lib/languages/useTranslate';
import { useGetAccountQuery } from 'lib/services/account';
import { AccountStatus } from 'lib/type/enums';

const useRestrictedAction = () => {
    const isAccountActivationRequired = useIsAccountActivationRequired();
    const dispatch = useDispatch();
    const translate = useTranslate('restrictedAction');
    const { data: account } = useGetAccountQuery();
    const isBlocked =
        account?.status === AccountStatus.BLOCKED ||
        account?.status === AccountStatus.SUSPENDED;

    const showAccountBlockedModal = () => {
        dispatch(
            showModal({
                type: ACCOUNT_BLOCKED_MODAL,
                props: {
                    closeModal: () => dispatch(hideModal()),
                },
            }),
        );
    };

    const showConfirmModal = () => {
        dispatch(
            showModal({
                type: CONFIRM_MODAL,
                props: {
                    handleSubmit: () => dispatch(hideModal()),
                    title: translate('title'),
                    message: translate('webMessage'),
                },
            }),
        );
    };

    const handleRestrictedAction = (func: () => void) => {
        if (isAccountActivationRequired) return showConfirmModal();
        if (isBlocked) return showAccountBlockedModal();
        func();
    };

    return {
        handleRestrictedAction,
        isAccountRestricted: isAccountActivationRequired || isBlocked,
    };
};

export default useRestrictedAction;
